import { RoundingType, TimesTypes } from './types';
export class TimeManager {
    fpsNumber;
    constructor(fpsNumber) {
        this.fpsNumber = fpsNumber;
    }
    active = {
        [TimesTypes.game]: false,
        [TimesTypes.total]: false
    };
    frames = {
        [TimesTypes.game]: 0,
        [TimesTypes.total]: 0
    };
    timeSpeed = 1;
    penaltyInfo = {
        count: 0,
        frames: 0,
        seconds: 0,
        secondsForOne: 0
    };
    lastTimeWithPenaltyInSeconds = {
        frame: 0,
        time: 0
    };
    getPenaltyInfo() {
        this.penaltyInfo.seconds = this.penaltyInfo.count * this.penaltyInfo.secondsForOne;
        return this.penaltyInfo;
    }
    getActive(type) {
        return this.active[type];
    }
    getFrames(type) {
        return this.frames[type];
    }
    setPenaltySecondsForOne(penalty) {
        this.penaltyInfo.secondsForOne = penalty;
    }
    getGameTimeInFormat(roundCount = 2) {
        return this.getTimeInFormat(this.frames[TimesTypes.game], roundCount);
    }
    getGameTimeWithPenaltyInSeconds(withRandom = false, randomNumber = 2, decimalCount = 2) {
        const frames = this.frames[TimesTypes.game] + this.penaltyInfo.frames;
        if (this.lastTimeWithPenaltyInSeconds.frame === frames) {
            return this.lastTimeWithPenaltyInSeconds.time;
        }
        const random = withRandom ? this.getRandomDecimal(0, randomNumber, decimalCount) : 0;
        if (withRandom)
            console.log(`random pripocet ku casu je ${random}`);
        const seconds = this.getSecondsFromFrames(frames, decimalCount);
        const decimalCoef = 10 ** decimalCount;
        this.lastTimeWithPenaltyInSeconds = {
            frame: frames,
            time: Math.round((seconds + random) * decimalCoef) / decimalCoef
        };
        return this.lastTimeWithPenaltyInSeconds.time;
    }
    getRandomDecimal(min, max, decimalCount = 2) {
        return (Math.floor(Math.random() * (max - min + 1)) + min) / (10 ** decimalCount);
    }
    getGameTimeWithPenaltyInFormat(roundCount = 2) {
        return this.getTimeInFormat(this.frames[TimesTypes.game] + this.penaltyInfo.frames, roundCount);
    }
    getTimeInFormat(frames, roundCount = 2) {
        return this.getTimeInFormatFromSeconds(this.getSecondsFromFrames(frames), roundCount);
    }
    getSecondsFromFrames(frames, roundCount = 2) {
        const roundMultiplier = 10 ** roundCount;
        const seconds = frames / this.fpsNumber;
        return Math.round(seconds * roundMultiplier) / roundMultiplier;
    }
    getTimeInFormatFromSeconds(secondsCount, roundCount = 2, roundingType = RoundingType.round) {
        const roundMultiplier = 10 ** roundCount;
        let seconds = 0;
        if (roundingType === RoundingType.round) {
            seconds = Math.round(secondsCount * roundMultiplier) / roundMultiplier;
        }
        else if (roundingType === RoundingType.floor) {
            seconds = Math.floor(secondsCount * roundMultiplier) / roundMultiplier;
        }
        else if (roundingType === RoundingType.ceil) {
            const tempResult = Number((secondsCount * roundMultiplier).toFixed(roundCount));
            seconds = Math.ceil(tempResult) / roundMultiplier;
        }
        let ms = Math.round(seconds * roundMultiplier);
        const mins = Math.floor((ms / roundMultiplier) / 60);
        ms -= (mins * 60 * roundMultiplier);
        const secs = Math.floor(ms / roundMultiplier);
        ms -= (secs * roundMultiplier);
        let timeFormat = '';
        if (mins > 0) {
            timeFormat += (`${mins}:`);
        }
        if (mins > 0 && secs < 10) {
            timeFormat += '0';
        }
        timeFormat += (`${secs.toString()}.`);
        if (ms < 10 && roundCount >= 2) {
            timeFormat += '0';
        }
        if (ms < 100 && roundCount >= 3) {
            timeFormat += '0';
        }
        timeFormat += ms.toString();
        return timeFormat;
    }
    static getTimeInSecondsLikeFormatted(seconds, roundCount = 2) {
        let ms = Math.ceil(seconds * (10 ** roundCount));
        const secs = Math.floor(ms / (10 ** roundCount));
        ms -= (secs * (10 ** roundCount));
        let timeFormat = (`${secs.toString()}.`);
        for (let i = 1; i < roundCount; i++) {
            if (ms < (10 ** i)) {
                timeFormat += '0';
            }
        }
        timeFormat += ms.toString();
        return timeFormat;
    }
    changeTimeSpeed(speed = 1) {
        this.timeSpeed = speed;
    }
    setActive(type, active) {
        this.active[type] = active;
    }
    addPenalty() {
        this.penaltyInfo.count++;
        this.penaltyInfo.frames += this.penaltyInfo.secondsForOne * this.fpsNumber;
    }
    update(paused) {
        if (paused)
            return;
        if (this.active[TimesTypes.total])
            this.frames[TimesTypes.total] += this.timeSpeed;
        if (this.active[TimesTypes.game])
            this.frames[TimesTypes.game] += this.timeSpeed;
    }
    reset() {
        this.active[TimesTypes.game] = false;
        this.active[TimesTypes.total] = false;
        this.frames[TimesTypes.game] = 0;
        this.frames[TimesTypes.total] = 0;
        this.penaltyInfo.count = 0;
        this.penaltyInfo.frames = 0;
    }
}
//# sourceMappingURL=TimeManager.js.map